import Vpp1 from "./vpp (1).webp";
import Vpp2 from "./vpp (2).webp";
import Vpp3 from "./vpp (3).webp";
import Vpp4 from "./vpp (4).webp";
import Vpp5 from "./vpp (5).webp";
import Vpp6 from "./vpp (6).webp";
import Vpp7 from "./vpp (7).webp";
import Vpp8 from "./vpp (8).webp";

const vpp = [Vpp1, Vpp2, Vpp3, Vpp4, Vpp5, Vpp6, Vpp7, Vpp8];

export default vpp;
